import { createReducer } from '@reduxjs/toolkit';
import ServiceStoreActions from './ServiceStoreActions';
import { ServiceStoreState } from './ServiceStoreState';

const initialState: ServiceStoreState = {
  isTesseractLoaded: false,
  isWebsocketConnected: false,
  isSmoEnvironmentImageClassifierLoaded: false,
  isSmoMoonTypeImageClassifierLoaded: false
};

export const serviceStoreReducer = createReducer<ServiceStoreState>(initialState, (builder) => {
  builder.addCase(ServiceStoreActions.setIsTesseractLoaded, (state, action) => ({
    ...state,
    isTesseractLoaded: action.payload
  }));
  builder.addCase(ServiceStoreActions.setIsWebsocketConnected, (state, action) => ({
    ...state,
    isWebsocketConnected: action.payload
  }));
  builder.addCase(ServiceStoreActions.setIsSmoEnvironmentImageClassifierLoaded, (state, action) => ({
    ...state,
    isSmoEnvironmentImageClassifierLoaded: action.payload
  }));
  builder.addCase(ServiceStoreActions.setIsSmoMoonTypeImageClassifierLoaded, (state, action) => ({
    ...state,
    isSmoMoonTypeImageClassifierLoaded: action.payload
  }));
});
